export interface GetLiveChatContactPersonResponse {
  data: {
    chat_group_id: string
  } | null
}
